import React, { Component } from 'react';
import { connect } from 'react-redux';

import { changeOutfit, toggleExpandedPossessions } from 'actions/myself';

import OutfitControlComponent from './OutfitControlComponent';
import { IAppState } from 'types/app';
import { IOutfit } from 'types/outfit';

export class OutfitControlContainer extends Component<Props> {
  handleChange = (evt: any) => {
    const { dispatch } = this.props;
    const outfitId = evt.target.value;
    dispatch(changeOutfit(outfitId));
  };

  handleToggleExpanded = () => {
    const { dispatch } = this.props;
    dispatch(toggleExpandedPossessions());
  };

  render = () => {
    const { isChanging, isExpanded, outfits } = this.props;
    if (!outfits.length) {
      return null;
    }

    const selectedOutfit = outfits.find(o => o.selected);

    return (
      <OutfitControlComponent
        isChanging={isChanging}
        isExpanded={isExpanded}
        onChange={this.handleChange}
        onToggleExpanded={this.handleToggleExpanded}
        outfits={outfits}
        selectedOutfit={selectedOutfit!}
      />
    );
  }
}

interface Props {
  dispatch: Function,
  isChanging: boolean,
  isExpanded: boolean,
  outfits: IOutfit[],
}

const mapStateToProps = ({
  myself: { character: { outfits } },
  outfit: { isChanging, isExpanded },
}: IAppState) => ({ outfits, isChanging, isExpanded });

export default connect(mapStateToProps)(OutfitControlContainer);